import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-25a49daa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "er-container" }
const _hoisted_2 = { class: "er-main" }
const _hoisted_3 = {
  key: 0,
  class: "u-wrong-num"
}
const _hoisted_4 = { class: "er-header-main" }
const _hoisted_5 = { class: "er-header-info" }
const _hoisted_6 = { class: "er-header-info-t" }
const _hoisted_7 = { class: "er-header-info-b" }
const _hoisted_8 = { class: "er-write-result" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "er-write-result-title" }, [
  /*#__PURE__*/_createTextVNode(" 作答结果"),
  /*#__PURE__*/_createElementVNode("span", { class: "er-write-result-title-s" }, "（点击题号查看解析）")
], -1))
const _hoisted_10 = { class: "er-write-result-tip" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "er-write-result-tip-l" }, "正确", -1))
const _hoisted_12 = {
  key: 0,
  class: "er-write-result-tip-p"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "er-write-result-tip-r" }, "错误", -1))
const _hoisted_14 = { class: "er-write-question-list-wrap" }
const _hoisted_15 = { class: "er-write-question-list" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "er-no-support"
}
const _hoisted_19 = { class: "er-write-footer flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_action_bar = _resolveComponent("new-action-bar")!
  const _component_question_analysis = _resolveComponent("question-analysis")!

  return (_openBlock(), _createElementBlock("div", {
    class: "m-report-wrap",
    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.preventDefaultEvent && $setup.preventDefaultEvent(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["er-header", `er-header-${$setup.testLevelInfoList[$setup.testLevel].bgKey}`])
        }, [
          _createVNode(_component_new_action_bar, {
            actionBarInfo: $setup.actionBarInfo,
            needShare: false,
            onGoBack: $setup.finish
          }, {
            right_operate_area: _withCtx(() => [
              _createElementVNode("div", {
                class: "m-error-link",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.gotoWrongList && $setup.gotoWrongList(...args)))
              }, [
                _createTextVNode(" 错题本"),
                ($setup.wrongNum)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($setup.wrongNum), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["actionBarInfo", "onGoBack"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, "正确率 " + _toDisplayString($setup.score) + "%", 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString($setup.testLevelInfoList[$setup.testLevel].inspireText), 1)
            ])
          ])
        ], 2),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            ($setup.source !== 'itembank')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, "部分正确"))
              : _createCommentVNode("", true),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.questionList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["er-write-question-item", `ans-status-${item.ansResStatus}`]),
                  key: item.queId,
                  onClick: ($event: any) => ($setup.goResolution(item, index))
                }, [
                  _createTextVNode(_toDisplayString(index + 1) + " ", 1),
                  (index % 4 === 0)
                    ? (_openBlock(), _createElementBlock("br", _hoisted_17))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_16))
              }), 128))
            ])
          ])
        ]),
        (!$setup.isAllDecidable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, " 注：不支持作答的试题，提交后系统默认作答结果正确 "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.reTry && $setup.reTry(...args)))
          }, _toDisplayString($setup.source === 'itembank' ? '继续练习' : '再次练习'), 1)
        ])
      ])
    ]),
    ($setup.showAnswerAnalysis)
      ? (_openBlock(), _createBlock(_component_question_analysis, {
          key: 0,
          onClose: $setup.closeAnalysis,
          index: $setup.currentIndex,
          sourceLocation: "test_report"
        }, null, 8, ["onClose", "index"]))
      : _createCommentVNode("", true)
  ]))
}